import { SuggestedSectionTitle } from 'src/component/lets-get-moving/suggested-section-title'
import { Button } from 'src/component/ui/button'
import { SUGGESTED_SERIES_ASPECT_CLASS } from 'src/constants/suggested-series'
import { useResetSuggestedSeriesFlow } from 'src/hook/use-reset-suggested-series-flow'
import React from 'react'

export const SuggestedSeriesExhausted = (): React.ReactElement => {
  const resetSuggestedSeriesFlow = useResetSuggestedSeriesFlow()

  return (
    <div data-testid="suggested-series-section">
      <div className="mb-8 lg:mb-10">
        <SuggestedSectionTitle>Series</SuggestedSectionTitle>
      </div>
      <div
        className={`rounded-md border border-tertiary-grey text-center ${SUGGESTED_SERIES_ASPECT_CLASS} items-center justify-center flex flex-col`}
      >
        <h4 className="font-evogria text-2xl uppercase leading-tight text-white md:text-3xl">Find your flow!</h4>
        <p className="mx-auto mt-3 max-w-xl font-roboto-condensed text-base leading-relaxed text-white md:mt-6 md:text-lg">
          You&apos;ve gone through every series in your
          <br /> suggested path. Reset your flow to start the
          <br /> journey from the beginning.
        </p>
        <Button
          type="button"
          className="mt-9 px-10"
          disabled={resetSuggestedSeriesFlow.isLoading}
          onClick={() => resetSuggestedSeriesFlow.mutate()}
          isLoading={resetSuggestedSeriesFlow.isLoading}
        >
          Reset flow
        </Button>
      </div>
    </div>
  )
}
